<template>
  <div class="main-chapter1">
    <n-loader :loading="$var('load')" />
    <div class="right-info">
      ВСН 012-88 (Часть 2)
    </div>
    <div class="chapter-title">Журнал производства земляных работ</div>
    <n-items v-if="project">
      <div style="width: 100%; text-align: center; margin-top: -20px">
        от км <n-input inline v-bind="$form.input('fromKm')"   :text="!editable" style="width: 80px" /> ПК <n-input inline  :text="!editable" v-bind="$form.input('fromPk')" style="width: 80px" /> и до км <n-input inline v-bind="$form.input('untilKm')" style="width: 80px" /> ПК <n-input inline v-bind="$form.input('untilPk')" style="width: 80px" />
      </div>
      <n-input title="Производитель работ" v-bind="$form.input('executor')" :text="!editable" />
      <n-input title="Начало работ" v-bind="$form.input('startedAt')" :text="!editable" />
      <n-input title="Окончание работ" v-bind="$form.input('endedAt')" :text="!editable" />
      <n-button v-if="editable" color="success" @click="submit">Сохранить</n-button>
    </n-items>
  </div>
</template>

<script>
export default {
  name: 'MainChapter1',
  props: {
    project: { type: Object, default: () => ({}), },
    journal: { type: Object, default: () => ({}), },
    editable: { type: Boolean, default: false, },
  },
  data: () => ({
  }),
  created() {
    this.$form.init(this.journal.data)
  },
  methods: {
    submit() {
      this.$var('load', true)
      $api.journals.edit(this.project.id, this.journal.name, this.$form.get()).then(() => {
        this.$emit('reload')
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .main-chapter1 {
  
  }
</style>
